import { SegmentEntityPanelProperties } from './base-entities-for-panel-properties.model';

export class LinePanelProperties extends SegmentEntityPanelProperties {
    type = 'AuxLine';

    constructor(element?: any, data?: any) {
        super(element, data);
    }
}
